module.exports = __webpack_public_path__ + "e2a4e0467bb6789bfba7d46e1000b2a7.svg";